import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesLeadActivityCategoriesDataGrid } from "src/components/views/erp/sales/crm/salesLeadActivityCategories/SalesLeadActivityCategoriesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/crm/salesLeadActivityCategories")({
	staticData: { title: i18n.t("sales_lead_activity_categories"), legacyViewKey: "salesLeadActivityCategoriesView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesLeadActivityCategoriesDataGrid />;
}
